import axios from "axios";
import { useEffect, useState } from "react";


export const useIp = () => {
    const [ip, setIp] = useState(null);

    useEffect(() => {
        const getIp = async () => {
            try {
                const ipResponse = await axios.get('https://api64.ipify.org?format=json');
                setIp(ipResponse?.data?.ip || null);
            } catch (error: any) {
                console.log('Failed to load IP address')
            }
        }
        getIp()
    }, []);

    return ip
}